import React from "react";
import styled from "styled-components";
import { Group } from "@domain/group/group";
import { useIsLearner } from "@domain/currentProfile/hooks";
import { useWorkspaces } from "@domain/group/workspace/hooks";
// import { Carousel } from "../../../components/carousel/carousel";
import { mobile } from "@ui/styles/utils";
import { CreateWorkspaceThumbnail } from "./createWorkspaceThumbnail";
import { WorkspaceThumbnail } from "./workspaceThumbnail";

const WORKSPACES_MAX_COUNT = 10;

interface WorkspacesCarouselProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}
export const WorkspacesCarousel: React.FC<WorkspacesCarouselProps> = ({ shareroom, ...htmlProps }) => {
	const { result: workspaces, totalElements } = useWorkspaces(shareroom.id);
	const isLearner = useIsLearner();
	const canCreateWorkspace = shareroom.userRole === "ADMINISTRATOR" && !isLearner;

	return (
		<Container {...htmlProps}>
			{canCreateWorkspace ? (
				<CreateWorkspaceThumbnail shareroom={shareroom} limitReached={(totalElements ?? 0) >= WORKSPACES_MAX_COUNT} />
			) : undefined}
			{workspaces.map((workspace) => (
				<WorkspaceThumbnail shareroom={shareroom} key={workspace.id} workspace={workspace} />
			))}
			{/* <Carousel
				title={I18n.t("shareroom.workspaces.title")}
				itemHeight={270}
				itemWidth={330}
				loading={loading}
				items={workspaces}
				renderItem={(workspace) => (
					<WorkspaceThumbnail shareroom={shareroom} key={workspace.id} workspace={workspace} />
				)}
				lastItem={
					shareroom.userRole === "ADMINISTRATOR" ? (
						<CreateWorkspaceThumbnail
							shareroom={shareroom}
							limitReached={(totalElements ?? 0) >= WORKSPACES_MAX_COUNT}
						/>
					) : undefined
				}
			/> */}
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	margin: 0 auto;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-gap: 45px;

	@media ${mobile} {
		grid-template-columns: repeat(1, 1fr);
		grid-gap: 15px;
	}
`;
